"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var discount_types_1 = require("../../types/discount.types");
var tax_computer_1 = require("../../utils/tax-computer");
var Product = /** @class */ (function () {
    function Product(_a) {
        var amount = _a.amount, taxRate = _a.taxRate, quantity = _a.quantity, _b = _a.tags, tags = _b === void 0 ? [] : _b, depth = _a.depth, uniqueDiscountableId = _a.uniqueDiscountableId, _isEligibleLuncheon = _a.isEligibleLuncheon, data = __rest(_a, ["amount", "taxRate", "quantity", "tags", "depth", "uniqueDiscountableId", "isEligibleLuncheon"]);
        this.applyOrder = discount_types_1.APPLY_ORDER.PRODUCT;
        this.type = discount_types_1.DISCOUNTABLE_TYPE.PRODUCT;
        this.amount = amount;
        this.discountedAmount = amount;
        this.remisedAmount = amount;
        this.taxRate = taxRate;
        this.quantity = quantity;
        this.tags = tags;
        this.parentTags = [];
        this.data = data;
        this.id = uniqueDiscountableId;
        this.isEligibleLuncheon = _isEligibleLuncheon || false;
        this.depth = depth;
    }
    Product.prototype.reset = function () {
        this.discountedAmount = this.amount;
    };
    Product.prototype.discount = function (discountAmount) {
        this.discountedAmount = this.discountedAmount.minus(discountAmount);
    };
    Product.prototype.applyRemise = function (remiseAmount) {
        this.remisedAmount = this.remisedAmount.minus(remiseAmount);
    };
    Object.defineProperty(Product.prototype, "luncheonEligibleTotalAmount", {
        get: function () {
            return this.isEligibleLuncheon ? this.totalPrice.totalInclTaxWithDiscount : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "totalPrice", {
        get: function () {
            return this.generatePriceBreakdown(this.amount, this.discountedAmount, this.remisedAmount, this.taxRate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "unitPrice", {
        get: function () {
            return this.generatePriceBreakdown(this.amount.dividedBy(this.quantity), this.discountedAmount.dividedBy(this.quantity), this.remisedAmount.dividedBy(this.quantity), this.taxRate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "recap", {
        get: function () {
            return {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                label: this.data.label,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                id: this.data.id,
                orderItemType: discount_types_1.DISCOUNTABLE_TYPE.PRODUCT,
                taxRate: this.taxRate,
                totalPrice: this.totalPrice,
                unitPrice: this.unitPrice,
                depth: this.depth,
                quantity: this.quantity,
                tags: this.tags,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                additionalData: this.data.additionalData,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                sku: this.data.sku,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
                purchasePrice: new bignumber_js_1.default(this.data.purchasePrice).toNumber(),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                billingCode: this.data.billingCode,
            };
        },
        enumerable: false,
        configurable: true
    });
    Product.prototype.generatePriceBreakdown = function (amount, discountedAmount, remisedAmount, taxRate) {
        var _a = (0, tax_computer_1.getPriceBreakdown)(amount, taxRate), totalInclTax = _a[0], totalExclTax = _a[1], totalTax = _a[2];
        var _b = (0, tax_computer_1.getPriceBreakdown)(discountedAmount, taxRate), totalInclTaxWithDiscount = _b[0], totalExclTaxWithDiscount = _b[1], totalTaxWithDiscount = _b[2];
        var _c = (0, tax_computer_1.getPriceBreakdown)(remisedAmount, taxRate), totalInclTaxWithRemise = _c[0], totalExclTaxWithRemise = _c[1], totalTaxWithRemise = _c[2];
        return {
            totalInclTax: totalInclTax,
            totalExclTax: totalExclTax,
            totalTax: totalTax,
            totalInclTaxWithDiscount: totalInclTaxWithDiscount,
            totalExclTaxWithDiscount: totalExclTaxWithDiscount,
            totalTaxWithDiscount: totalTaxWithDiscount,
            totalInclTaxWithRemise: totalInclTaxWithRemise,
            totalExclTaxWithRemise: totalExclTaxWithRemise,
            totalTaxWithRemise: totalTaxWithRemise,
        };
    };
    return Product;
}());
exports.Product = Product;
